import { render } from "./SidebarButtons.vue?vue&type=template&id=c4cb62fa&scoped=true"
import script from "./SidebarButtons.vue?vue&type=script&lang=js"
export * from "./SidebarButtons.vue?vue&type=script&lang=js"

import "../../assets/scss/document_edit.scss?vue&type=style&index=0&id=c4cb62fa&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4cb62fa"]])

export default __exports__